import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { domain } from '../variables/domain';
import { LoadingController } from '@ionic/angular';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EncryptionService } from './encryption.service';
import { SharedServices } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class AddAgentPropertiesService {
private isPropertyPost = new Subject<any>();
  constructor(private http: HttpClient, private encryptionService: EncryptionService,private sharedServices:SharedServices
  ) { }
  setPropertyPost(value) {
    this.isPropertyPost.next(value);
  }
  public get getPropertyPost() {
    return this.isPropertyPost.asObservable();
  }
  addUserDefineArea(details) {
    return this.http
      .post(domain.userDefineArea + 'PostUserDefinedArea', details)
      .pipe(map((res:any) => res));
  }
  addUserDefineSociety(details) {
    return this.http
      .post(domain.userDefineSociety + 'PostUserDefinedSociety', details)
      .pipe(map((res:any) => res));
  }
  commercialSaleForm(details) {
    return this.http
      .post(domain.addProperties + 'AddProperty', details)
      .pipe(map((res:any) => res));
  }

   saveImage(file, propID) { 
    return this.http
      .post(domain.addProperties + 'savePropertyImage?propertyId=' + propID, file)
      .pipe(map((res:any) => res))
  }
   DeletePropertyImage(imageId) { 
    return this.http
      .post(domain.addProperties + 'DeletePropertyImage?imageId=' + imageId,{})
      .pipe(map((res:any) => res))
  }
  UpdateProperty(details) {
    return this.http
      .post(domain.addProperties + 'UpdateProperty', details)
      .pipe(map((res:any) => res));
  }


  SearchSocietyList(key,skip,take){
    return this.http
    .get(domain.searchSociety+"?search="+key+"&skip="+skip+"&take="+take)
    .pipe(map((res:any) => res));
  }
  getUserHistory(){
    return this.http
    .get(domain.UsersSubscriptionList+  this.sharedServices.getAgentId())
    .pipe(map((res:any) => res));
  }
  SearchPropertyByNumber(mobileNo){
    return this.http
    .get(domain.SearchPropertyByNumber+ 'userId='+ this.sharedServices.getAgentId()+'&mobileNo=' + mobileNo)
    .pipe(map((res:any) => res));
  }
 
}
